import React from "react";
import { getTranslateByKey } from "@/main/services/utils";
import BoxGrid from "@/main/components/shared/boxGrid/boxGrid";
import KOGPaginationGrid from "@/main/components/shared/paginationGrid/paginationGrid";
import { integrationQueueApi } from "@/main/api";
import { IntegrationQueueRequest } from "@/main/models/request";
import { IntegrationQueueResponse } from "@/main/models/response";
import RowDataIntegration from "./rowDataIntegration/rowDataIntegration";
import * as S from "./styles";

interface IGridIntegrationProps {
	dataGrid: IntegrationQueueResponse[];
	formFilters: IntegrationQueueRequest | null;
	setDataGrid: React.Dispatch<React.SetStateAction<IntegrationQueueResponse[]>>;
	getDataIntegrationQueue: (filters?: Partial<IntegrationQueueRequest>, isResetSearch?: boolean) => void;
}

function GridIntegration({ dataGrid, formFilters, setDataGrid, getDataIntegrationQueue }: IGridIntegrationProps) {
	const rowsHeader = [
		getTranslateByKey("information.date"),
		getTranslateByKey("information.claimNumber"),
		getTranslateByKey("information.insurer"),
		getTranslateByKey("information.bodyshop"),
		getTranslateByKey("module.integration"),
		getTranslateByKey("information.errorDescription"),
		getTranslateByKey("information.attempts"),
		getTranslateByKey("information.status"),
		getTranslateByKey("information.actions"),
	];
	async function fetchDataIntegrationQueue(request: any) {
		return integrationQueueApi.getSearchGrid(request).then((response) => response.data);
	}

	if (dataGrid.length === 0 && formFilters === null) return null;

	return (
		<S.Container>
			<KOGPaginationGrid
				showTitleResults
				dataGrid={dataGrid}
				formFilters={formFilters}
				setDataGrid={setDataGrid}
				fetchEqualFilters
				fetchMore={fetchDataIntegrationQueue}
			>
				<BoxGrid rowHeaders={rowsHeader}>
					{dataGrid.map((item) => (
						<RowDataIntegration
							key={item.guidIntegrationQueue}
							integrationQueue={item}
							getDataIntegrationQueue={getDataIntegrationQueue}
						/>
					))}
				</BoxGrid>
			</KOGPaginationGrid>
		</S.Container>
	);
}

export default GridIntegration;
